import React from "react";
import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

export function Movement({ value, className = "", dark = false }) {
  if (value === 0 || value == null)
    return (
      <span className={`inline-flex items-center gap-1 text-xs font-semibold ${dark ? "text-white/50" : "text-ink-3"} ${className}`}>
        <Minus size={13} strokeWidth={1.5} /> 0
      </span>
    );
  const up = value > 0;
  const upColor = dark ? "#B6E14F" : "#678A16";
  const downColor = dark ? "#F0A3A3" : "#D95C5C";
  return (
    <span
      className={`inline-flex items-center gap-0.5 text-xs font-bold ${className}`}
      style={{ color: up ? upColor : downColor }}
    >
      {up ? <ArrowUpRight size={14} strokeWidth={2} /> : <ArrowDownRight size={14} strokeWidth={2} />}
      {up ? "+" : ""}
      {value}
    </span>
  );
}

export function StatusPill({ status, dark = false }) {
  const light = {
    Excellent: { bg: "rgba(147,192,32,.12)", fg: "#678A16" },
    Growing: { bg: "rgba(147,192,32,.12)", fg: "#678A16" },
    Steady: { bg: "rgba(229,169,61,.14)", fg: "#B47A1C" },
    "Needs work": { bg: "rgba(217,92,92,.12)", fg: "#B23B3B" },
  };
  const dk = {
    Excellent: { bg: "rgba(182,225,79,.16)", fg: "#B6E14F" },
    Growing: { bg: "rgba(182,225,79,.16)", fg: "#B6E14F" },
    Steady: { bg: "rgba(229,169,61,.18)", fg: "#E5C07B" },
    "Needs work": { bg: "rgba(217,92,92,.2)", fg: "#F0A3A3" },
  };
  const map = dark ? dk : light;
  const s = map[status] || map.Steady;
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider"
      style={{ background: s.bg, color: s.fg }}
    >
      {status}
    </span>
  );
}
